import React,{useState} from 'react';

// tag input
import { WithContext as ReactTags } from 'react-tag-input';
import '../common/Util/TagStyle.css';

// http axios
import axios from 'axios';
import axiosUrl from '../../axios/url';
 
// custom function
import ContentsHeader from './ContentsHeader';
import ImageUploader from '../common/Util/ImageUploader';

export default function QuizCreate(param) {

    const [quizList, setquizList] = useState([{
                                                question: "", 
                                                questionType : "text", 
                                                answerSelectionType: "single", 
                                                answers : [], 
                                                correctAnswer: [], 
                                                correctAnswerTemp: "",
                                                messageForCorrectAnswer: "",
                                                messageForIncorrectAnswer: "",
                                                explanation: ""
                                             }]);
    const [quizNumber, setquizNumber] = useState('');
    const [title, setTitle] = React.useState('');
    const [opened, setOpened] = React.useState(false);
    const [thumbFile, setThumbFile] = React.useState('');
    const [reference, setReference] = React.useState('');
    const [keywordTags, setKeywordTags] = useState([]);
    const [check, setCheck] = useState(true);

    //----- onchange event setting start
    function onChangeTitle(e){  setTitle(e.target.value); }

    // 공개여부 변경
    function onChangeOpened(e){ setOpened(e.target.checked);}

    // 검색어 태그 삭제
    function handleKeywordDelete(i) {  setKeywordTags(keywordTags.filter((tag, index) => index !== i)); }

    // 검색어 태그 추가
    function handleKeywordAddition(tag) {  setKeywordTags([...keywordTags, {id :keywordTags.tag.text, text:tag.text}]); }

    // 참고문헌 변경
    function onChangeReference(e){  setReference(e.target.value); }

    function quizNumberCheck(i) {
        setquizNumber(i);
    }

    function quizAdd() {
        var temp = quizList;
        temp.push({
            question: "", 
            questionType : "text",
            answerSelectionType: "single", 
            answers : [], 
            correctAnswer: [], 
            correctAnswerTemp: "",
            messageForCorrectAnswer: "",
            messageForIncorrectAnswer: "",
            explanation: ""
         });
        setquizList(temp);
        setCheck(!check)
    }

    function quizDelete(i) {
        var temp = quizList;
        temp.splice(i, 1);
        setquizList(temp);
        setCheck(!check);
    }

    function questionChange(i, value) {
        quizList[i].question = value;
        setCheck(!check);
    }

    function questionTypeChange(i, value) {
        quizList[i].questionType = value;
        quizList[i].answers = [];
        setCheck(!check);
    }

    function answerSelectionTypeChange(i, value) {
        quizList[i].answerSelectionType = value;
        setCheck(!check);
    }

    function answerAdd(i) {
        var temp = quizList[i].answers;
        temp.push("");
        setCheck(!check);
    }
    
    function answerChange(i, j, value) {
        quizList[i].answers[j] = value;
        setCheck(!check);
    }

    function answerdelete(i, j) {
        var temp = quizList[i].answers;
        temp.splice(j, 1);
        setCheck(!check);
    }
    
    function correctAnswerChange(i, value) {
        quizList[i].correctAnswerTemp = value;
        setCheck(!check);
    }
    
    function messageForCorrectAnswerChange(i, value) {
        quizList[i].messageForCorrectAnswer = value;
        setCheck(!check);
    }
     
    function messageForIncorrectAnswerChange(i, value) {
        quizList[i].messageForIncorrectAnswer = value;
        setCheck(!check);
    }
     
    function explanationChange(i, value) {
        quizList[i].explanation = value;
        setCheck(!check);
    }

    function onChangeThumbFile(imageFile){
        var formData = new FormData();
        formData.append('file', imageFile[0])
        return axios.post(axiosUrl.fileupload, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Max-Age': '3600',
              'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
          }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            setThumbFile(res.data.filename);
          }).catch( e => {
                console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
          })
    }

    function onChangeImageFile(imageFile){
        
        var formData = new FormData();
        imageFile.map(image => {
            formData.append('file', image);
        }) 
        return axios.post(axiosUrl.fileupload + "/multiple", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Max-Age': '3600',
              'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
          }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            quizList[quizNumber].answers = res.data.filename;
          }).catch( e => {
            console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
          })
    }

    React.useEffect(() => {
    }, check);

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    async function savequiz(e){
        if(trim(title) === ''){ alert('제목을 확인하세요.'); return;}
        var list = [];
        quizList.map((quiz, quizOrder) => {
            var items = [];
            quiz.answers.map((answer, i) => {
                items.push({body: answer, order: i+1});
            })
            var temp = {
                question: quiz.question,
                questionType: quiz.questionType.toUpperCase(),
                selectionType: quiz.answerSelectionType.toUpperCase(),
                answers: quiz.correctAnswerTemp,
                correctMessage: quiz.messageForCorrectAnswer,
                incorrectMessage: quiz.messageForIncorrectAnswer,
                description: quiz.explanation,
                order: quizOrder,
                items: items
            }
            list.push(temp);
        })

        var tagString = "" ;
        keywordTags.map((tag, i) => {
            if( i === 0) {
                tagString = tagString + tag.text;
            } else {
                tagString = tagString +","+ tag.text;
            }
        })

        var sendData = {
            type: "Quiz",
            title: title,
            keyword: tagString,
            reference: reference,
            thumbnailUrl: thumbFile,
            opened: opened,
            quizzes: list
        }
       
        var url = axiosUrl.quizzes;  
        await axios.post(url,sendData)
        .then(function (response){
            alert('퀴즈 추가되었습니다.');
            goList(e); 
         })
        .catch(function (e) {
            alert('콘텐츠가 등록에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] - ' + e.response.data.error.message);
        });
    }

    function goList(e){
        window.location = '/contents/quiz';
    }

    return(
        <div >
            <div className="content-wrapper">
                <ContentsHeader  />
                <section className="content" >
                    <div className="row">
                         <div className="col-12">
                            <button  className="btn float-right" type="button" onClick={quizAdd}>
                                <h3 className="card-title"><i className="fas fa-plus mr-1"></i> 퀴즈 추가 </h3>
                            </button>
                        </div>
                        <div className="col-6">
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">기본정보</h3>
                                </div>
                                <div className="card-body">
                                    <h3 className="card-title">제목</h3>
                                    <input type="text" className="form-control" id="title11" placeholder="제목을 입력하세요.." onChange={onChangeTitle} />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">썸네일</h3>
                                </div>
                                <div className="card-body">
                                    <ImageUploader callbackImage={onChangeThumbFile} />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">검색어</h3>
                                </div>
                                <div className="card-body">
                                    <ReactTags id="keywordTag"
                                        tags={keywordTags}
                                        placeholder='검색어'
                                        handleDelete={handleKeywordDelete}
                                        handleAddition={handleKeywordAddition}
                                        autofocus={false}
                                        readOnly={false}
                                    />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">참고문헌</h3>
                                </div>
                                <div className="card-body">
                                    <input type="text" className="form-control" id="title" placeholder="내용을 입력하세요.." onChange={onChangeReference} />
                                </div>
                            </div>
                            <div className="card card-danger">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">공개여부</h3>
                                </div>
                                <div className="card-body">
                                    <div className="custom-control custom-switch">
                                        <input type="checkbox" className="custom-control-input" id="opened" onChange={onChangeOpened} />
                                        <label className="custom-control-label" htmlFor="opened">공개</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6" id="accordionTag">
                            {quizList.map((quiz, i) => (
                                <div className="card" key={i}>
                                    <div className="card-header contentColor">
                                        <button  className="btn p-0" type="button" data-toggle="collapse" data-target={"#collapse"+i} aria-expanded="true" aria-controls={"collapse"+i} onClick={() => quizNumberCheck(i)}>
                                            <h3 className="card-title">{quiz.question || "알수 없음"}</h3>
                                        </button>
                                        <button  className="btn p-0 float-right" type="button" onClick={() => quizDelete(i)}>
                                            <i className="fas fa-trash-alt text-black-50" />
                                        </button>
                                    </div>
                                    <div className="card-body collapse"  id={"collapse"+i} aria-labelledby={"heading"+i} data-parent="#accordionTag">
                                        <div className="d-flex">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">질문</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="질문을 입력하세요.." onChange={(e) => questionChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">질문유형</h3>
                                                        <select  className="form-control" onChange={(e) => questionTypeChange(i, e.target.value)}> 
                                                            <option value="text">text</option>
                                                            <option value="photo">image</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">정답유형</h3>
                                                        <select  className="form-control" onChange={(e) => answerSelectionTypeChange(i, e.target.value)}>
                                                            <option value="single">single</option>
                                                            <option value="multiple">multiple</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {
                                                    quiz.questionType === "text" 
                                                    ? (
                                                        <div className="card">
                                                            <div>
                                                                <button  className="btn float-right mt-2" type="button" onClick={(e) => answerAdd(i)}>
                                                                    <h3 className="card-title"><i className="fas fa-plus mr-1"></i> 보기 추가</h3>
                                                                </button>
                                                            </div>
                                                            <div className="card-body pt-1">
                                                            {quiz.answers.map((answer, j) => (
                                                                <div className="mb-2" key={j}>
                                                                    <div>
                                                                        <h3 className="card-title">보기</h3>
                                                                    </div>
                                                                    <div className="d-flex margin-top col-12 p-0">
                                                                        <input type="text" className="w-75 form-control" id="title11" placeholder="보기를 입력하세요.." onChange={(e) => answerChange(i, j, e.target.value)} />
                                                                        <buttom className="btn btn-default btn-primary ml-2 p-1" onClick={(e) => answerdelete(i, j)}>삭제</buttom>
                                                                    </div>
                                                                    
                                                                </div>
                                                            ))}
                                                            </div>
                                                        </div>
                                                    )
                                                    : (
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <h3 className="card-title">이미지</h3>
                                                                <ImageUploader callbackImage={onChangeImageFile}/>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="mb-1">
                                                            <h3 className="card-title">정답</h3>
                                                            <input type="text" className="form-control" id="title11" placeholder="정답을 입력하세요.." value={quiz.correctAnswerTemp} onChange={(e) => correctAnswerChange(i, e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">정답시 메시지</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="메시지을 입력하세요.." onChange={(e) => messageForCorrectAnswerChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">오답시 메시지</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="메시지을 입력하세요.." onChange={(e) => messageForIncorrectAnswerChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">설명</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="설명을 입력하세요.." onChange={(e) => explanationChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="button-wrapper mb-5 col-12"  >
                            <button onClick={savequiz} type="button" className="btn btn-primary mr-1"><i className="fas fa-plus"></i> 새 슬라이드 저장하기</button>
                            <button onClick={goList} type="button" className="btn btn-primary"><i className="fas fa-list"></i> 목록</button>
                        </div>
                    </div>
                </section>
             </div>
        </div>
    );
}